import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Landing from './pages/generalPages/Landing';
import UserDashboard from './pages/userDashboard/index';
import SignIn from './pages/authentication/signIn';
import CreateAccount from './pages/authentication/createAccount';
import Donation from './pages/donation/donate';
import CampaignDetail from './pages/Campaigns/campaignDetail';
import { ToastContainer } from 'react-toastify';
import AllCampaigns from './pages/Campaigns/allCampaigns';
import HowItWorks from './pages/generalPages/HowItWorks';
import PasswordResetToken from './pages/authentication/generatePasswordResetToken';
import ResetPassword from './pages/authentication/resetPassword';
import { useEffect } from 'react';
import GratitudeChallenge from './pages/Campaigns/gratitudeChallenge';
import CompletedCampaigns from './pages/Campaigns/allCompletedCampaigns';
import NotFound from './pages/errorPages/errorPage';
import UserCampaignsList from './pages/Campaigns/userCampaignsList';

function App() {
   
   function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
     }, [pathname])
   }

  return (
    <>
    <ToastContainer
      bodyClassName={() => "toastBody flex items-center text-xs "}
    />
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/all-campaigns" element={<AllCampaigns />} />
        <Route path="/completed-campaigns" element={<CompletedCampaigns />} />
        <Route path="/campaign-detail/:campaignReference" element={<CampaignDetail />} />
        <Route path="/campaigns/:email" element={<UserCampaignsList />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<CreateAccount />} />
        <Route path="/gratitude" element={<GratitudeChallenge />} />
        <Route path="/donate/:campaignReference/:title" element={<Donation />} />
        <Route path="/forgot-password" element={<PasswordResetToken />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/dashboard/*" element={<UserDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
